// T020: React-Phaser Container Component

import { useEffect, useRef } from 'react';
import Phaser from 'phaser';
import { gameConfig } from '../../game/config';

interface GameContainerProps {
  onGameReady?: (game: Phaser.Game) => void;
}

/**
 * React component that wraps Phaser game instance.
 * Handles lifecycle management and cleanup.
 */
export function GameContainer({ onGameReady }: GameContainerProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const gameRef = useRef<Phaser.Game | null>(null);

  useEffect(() => {
    if (!containerRef.current || gameRef.current) return;

    // Create game config with the container element
    const config: Phaser.Types.Core.GameConfig = {
      ...gameConfig,
      parent: containerRef.current,
    };

    // Initialize Phaser game
    const game = new Phaser.Game(config);
    gameRef.current = game;

    // 暴露遊戲實例給瀏覽器控制台和自動化測試
    (window as unknown as { __GAME__: Phaser.Game }).__GAME__ = game;

    // Notify parent when game is ready
    if (onGameReady) {
      game.events.once('ready', () => {
        onGameReady(game);
      });
    }

    // Cleanup on unmount
    return () => {
      if (gameRef.current) {
        gameRef.current.destroy(true);
        gameRef.current = null;
      }
    };
  }, [onGameReady]);

  return (
    <div
      ref={containerRef}
      id="game-container"
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    />
  );
}
